import React from "react";
import ReactDOM from "react-dom";
import { history } from "globalhistory";
import App from "./app";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import { Router } from "react-router";
import store from "stores";
import "./style.scss";
import Metrika from "app/metrika";

const Root = (
  <React.StrictMode>
    <Metrika />
    <Provider store={store}>
      <Router history={history}>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>
);

const element = document.getElementById("root");
if (element?.hasChildNodes()) {
  ReactDOM.hydrate(Root, element);
} else {
  ReactDOM.render(Root, element);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
